import React from "react";
import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "Plataforma",
    links: [
      { label: "Agenda Inteligente", href: "#features" },
      { label: "Prontuário Digital", href: "#features" },
      { label: "Portal do Tutor", href: "#tour" },
      { label: "Painel do Gestor", href: "#admin" },
      { label: "Planos", href: "#pricing" },
    ],
  },
  {
    title: "Suporte",
    links: [
      { label: "Perguntas Frequentes", href: "#faq" },
      {
        label: "Falar no WhatsApp",
        href: "https://wa.me/5516997502577",
        external: true,
      },
    ],
  },
];

const LEGAL = [
  { label: "Privacidade", to: "/privacidade" },
  { label: "Termos de Uso", to: "/termos-de-uso" },
];

const Footer = () => (
  <footer className="relative overflow-hidden border-t border-midnight/[.07] bg-white pb-10 pt-20">
    {/* Marca d'água gigante no fundo */}
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-8 left-1/2 hidden -translate-x-1/2 select-none font-display text-[13vw] font-extrabold leading-none tracking-tighter text-midnight/[.035] lg:block"
    >
      PawSuite
    </span>

    <div className="relative mx-auto max-w-7xl px-6">
      <div className="mb-16 grid gap-12 md:grid-cols-4">
        <div data-purpose="footer-logo">
          <div className="mb-5 flex items-center gap-2.5">
            <img
              src="/logo.png"
              alt="PawSuite"
              className="h-9 w-auto object-contain"
            />
            <span className="font-display text-xl font-extrabold text-midnight">
              PawSuite<span className="text-pawOrange">.</span>
            </span>
          </div>
          <p className="mb-6 max-w-xs leading-relaxed text-midnight/50">
            A tecnologia que seu pet shop merece para crescer com qualidade.
          </p>

          <a
            href="https://wa.me/5516997502577"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2.5 rounded-full border border-midnight/10 px-4 py-2 text-sm font-semibold text-midnight/70 transition-all duration-300 hover:border-tealVitality/40 hover:bg-tealVitality/[.06] hover:text-tealVitality"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.38-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.42-.07-.13-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2z" />
            </svg>
            (16) 99750-2577
          </a>
        </div>

        {COLUMNS.map((column) => (
          <div key={column.title}>
            <h5 className="mb-5 font-display font-bold text-midnight">
              {column.title}
            </h5>
            <ul className="space-y-3.5">
              {column.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    {...(link.external
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : {})}
                    className="group inline-flex items-center gap-1.5 text-midnight/50 transition-colors duration-300 hover:text-tealVitality"
                  >
                    <span className="h-px w-0 bg-tealVitality transition-all duration-300 group-hover:w-3" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h5 className="mb-5 font-display font-bold text-midnight">Legal</h5>
          <ul className="space-y-3.5">
            {LEGAL.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="group inline-flex items-center gap-1.5 text-midnight/50 transition-colors duration-300 hover:text-tealVitality"
                >
                  <span className="h-px w-0 bg-tealVitality transition-all duration-300 group-hover:w-3" />
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-midnight/[.07] pt-8 sm:flex-row">
        <p className="text-sm text-midnight/40">
          © {new Date().getFullYear()} PawSuite Technologies. Todos os direitos
          reservados.
        </p>
        <p className="flex items-center gap-2 text-sm text-midnight/40">
          Feito com
          <span className="text-pawOrange">♥</span>
          para quem cuida de pets
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
